module.exports = __webpack_public_path__ + "static/media/ktm-12.1d71e2a6.png";